// Copyright (c) 2017 Deere & Company

import './warranty-date-range-picker.scss';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import React, {Component, PropTypes} from 'react';
import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import WarrantyDatePicker from '../warranty-date-picker';
import {buildMoment} from '../../../shared/services/build-moment';

const convertDateToInteger = date => date ? date.utc().startOf('day').valueOf() : date;

function handleChange(startDate, endDate) {

    this.setState({
        endDate,
        startDate
    });

    this.props.onDateChange({
        from: convertDateToInteger(startDate),
        to: convertDateToInteger(endDate)
    });

}

function handleChangeStart(startDate) {

    const newStartDate = startDate ? startDate : null;

    this::handleChange(newStartDate, this.state.endDate);

}

function handleChangeEnd(endDate) {

    const newEndDate = endDate ? endDate : null;

    this::handleChange(this.state.startDate, newEndDate);

}

class WarrantyDateRangePicker extends Component {

    constructor(props) {

        super(props);

        this.state = {
            endDate: null,
            startDate: null
        };

    }

    componentWillMount() {

        /* eslint-disable no-undefined */
        /* third party library react-datepicker does not recognize 'null' only 'undefined' */

        this.setState({
            endDate: buildMoment(this.props.dateRange.to),
            maxDate: this.props.maxDate ? buildMoment(this.props.maxDate) : undefined,
            minDate: this.props.minDate ? buildMoment(this.props.minDate) : undefined,
            startDate: buildMoment(this.props.dateRange.from)
        });

        /* eslint-enable no-undefined */

    }

    componentWillReceiveProps(nextProps) {

        this.setState({
            endDate: buildMoment(nextProps.dateRange.to),
            startDate: buildMoment(nextProps.dateRange.from)
        });

    }

    render() {

        return (
            <ul className='date-range'>
                <li>
                    <WarrantyDatePicker
                        endDate={this.state.endDate}
                        maxDate={this.state.maxDate}
                        minDate={this.state.minDate}
                        onChange={this::handleChangeStart}
                        selected={this.state.startDate}
                        startDate={this.state.startDate}
                    />
                </li>
                <li className='range-text'>
                    <FormattedMessage id='TO'/>
                </li>
                <li>
                    <WarrantyDatePicker
                        endDate={this.state.endDate}
                        maxDate={this.state.maxDate}
                        minDate={this.state.minDate}
                        onChange={this::handleChangeEnd}
                        selected={this.state.endDate}
                        startDate={this.state.startDate}
                    />
                </li>
            </ul>
        );

    }

}

WarrantyDateRangePicker.displayName = 'WarrantyDateRangePicker';
WarrantyDateRangePicker.propTypes = {
    dateRange: PropTypes.instanceOf(DateRange).isRequired,
    intl: intlShape.isRequired,
    maxDate: PropTypes.number,
    minDate: PropTypes.number,
    onDateChange: PropTypes.func.isRequired
};
WarrantyDateRangePicker.defaultProps = {
    maxDate: null,
    minDate: null
};
export default injectIntl(WarrantyDateRangePicker);



// WEBPACK FOOTER //
// ./src/shared/components/warranty-date-range-picker/warranty-date-range-picker.js